import React from 'react';
import styled from 'styled-components';
import RaiseNowPaymentButton from './raise_now_payment_button';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
`

const ResponsiveImage = styled.img`
  max-width: 100%;
  height: auto;
  object-fit: cover;
`

const roundPrice = number => {
  var roundedToPrecision = +(Math.round(number + "e+2")  + "e-2");
  return (Math.round(20 * roundedToPrecision) / 20).toFixed(2)
}

const price = (portfolio, emissions) => roundPrice(portfolio.pricePerT.value * emissions);

export default ({ portfolio, emissions, switchToPayment, displayState }) => (
  <Container key={portfolio.key}>
    <ResponsiveImage src={portfolio.image} />
    <div><strong>{ portfolio.key }</strong></div>
    <span>{ portfolio.pricePerT.currency } { price(portfolio, emissions) }</span>
    <div><RaiseNowPaymentButton price={ price(portfolio, emissions) } switchToPayment={ () => switchToPayment(portfolio) } displayState={displayState} portfolio={portfolio} /></div>
  </Container>
)
